var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Defaults, ViewChild, PropertyConverters, Utils } from '@pacem/pacem-core';
import { PacemOrdinalInputElement } from './input';
//namespace Pacem.Components.Scaffolding {
let PacemNumberInputElement = class PacemNumberInputElement extends PacemOrdinalInputElement {
    toggleReadonlyView(readonly) {
        this._span.hidden = !readonly;
        this._input.hidden = readonly;
    }
    get inputFields() {
        return [this._input];
    }
    getViewValue(val) {
        return this.value != null ? this._format(this.value) : undefined;
    }
    _format(v = this.value) {
        const intl = this.format;
        if (!Utils.isNullOrEmpty(intl)) {
            return new Intl.NumberFormat(Utils.lang(this), intl).format(v);
        }
        return v.toString();
    }
    getValue(val) {
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/669685/ (bug open since Aug 2014!)
        const v = this.inputField.valueAsNumber || parseFloat(this.inputField.value);
        return isNaN(v) ? undefined : v;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        var options = { capture: false, passive: false };
        this._input.addEventListener("wheel", this.emitHandler, options);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._input)) {
            var options = { capture: false, passive: false };
            this._input.removeEventListener("wheel", this.emitHandler, options);
        }
        super.disconnectedCallback();
    }
};
__decorate([
    ViewChild('input[type=number]')
], PacemNumberInputElement.prototype, "_input", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemNumberInputElement.prototype, "_span", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemNumberInputElement.prototype, "format", void 0);
PacemNumberInputElement = __decorate([
    CustomElement({ tagName: P + '-input-number', template: `<input type="number" class="${PCSS}-input ${PCSS}-viewfinder" /><span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>`, shadow: Defaults.USE_SHADOW_ROOT })
], PacemNumberInputElement);
export { PacemNumberInputElement };
